import {
  differenceInDays,
  format,
  formatDistanceToNow,
  getTime,
  parseISO,
} from "date-fns";

// ----------------------------------------------------------------------

export function fDate(date: Date | string | number) {
  return format(new Date(date), "dd MMMM yyyy");
}

export function fShortDate(date: Date | string | number) {
  return format(new Date(date), "dd/MM/yy");
}

export function fDateTime(date: Date | string | number) {
  return format(new Date(date), "dd MMM yyyy p");
}

export function fTimestamp(date: Date | string | number) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date: Date | string | number) {
  return format(new Date(date), "dd/MM/yyyy hh:mm p");
}

export function fToNow(date: Date | string | number) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true,
  });
}

export function fUnixTimestamp(date: string) {
  const timestamp = parseInt(date) * 1000;
  return format(new Date(timestamp), "dd MMMM yyyy");
}

export function humanReadableDateTime(date: Date) {
  return `${format(date, "p do")} ${format(date, "MMMM")}`;
}

export function daysBetweenDates(
  startDateString: string,
  endDateString: string,
) {
  const startDate = parseISO(startDateString);
  const endDate = parseISO(endDateString);
  return differenceInDays(startDate, endDate);
}

export const formatAverageRuntime = (durationString: string): string => {
  const hasDays = durationString.includes("days");

  let days = 0;
  let timePart = durationString;

  if (hasDays) {
    const [daysPart, timePartPart] = durationString.split(", ");
    days = parseInt(daysPart.split(" ")[0], 10);
    timePart = timePartPart;
  }

  const [hours, minutes] = timePart.split(":").map(parseFloat);

  const totalHours = days * 24 + hours;
  const totalMinutes = minutes;

  const formattedDuration = `${days} days (${totalHours} hours ${totalMinutes} minutes)`;

  return formattedDuration;
};
